import { render, staticRenderFns } from "./klaviyo-webhook-instructions.vue?vue&type=template&id=15366d20&"
import script from "./klaviyo-webhook-instructions.vue?vue&type=script&lang=js&"
export * from "./klaviyo-webhook-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports